import { SagasService } from "../../shared/services/sagas"
import { rootSaga } from "./sagas"

export const init = () => {
  SagasService.set(rootSaga)
}
